import React from 'react';
import styles from './StepProgress.module.css';

interface StepProgressProps {
  currentStep: number;
  totalSteps: number;
  stepNames: string[];
  onStepClick?: (stepNumber: number) => void;
}

const StepProgress: React.FC<StepProgressProps> = ({ 
  currentStep, 
  totalSteps, 
  stepNames,
  onStepClick
}) => {
  return (
    <div className={styles.stepProgress}>
      <div className={styles.progressHeader}>
        
      </div>
      
      <div className={styles.progressBar}>
        {Array.from({ length: totalSteps }, (_, index) => {
          const stepNumber = index + 1;
          const isCompleted = stepNumber < currentStep;
          const isCurrent = stepNumber === currentStep;
          
          return (
            <div key={stepNumber} className={styles.stepContainer}>
              <div 
                className={`${styles.stepCircle} ${
                  isCompleted ? styles.completed : 
                  isCurrent ? styles.current : 
                  styles.pending
                } ${onStepClick ? styles.clickable : ''}`}
                onClick={() => onStepClick?.(stepNumber)}
              >
                {isCompleted ? (
                  <svg width="12" height="12" viewBox="0 0 24 24" fill="none">
                    <path 
                      d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41L9 16.17z" 
                      fill="currentColor"
                    />
                  </svg>
                ) : (
                  <span className={styles.stepNumber}>{stepNumber}</span>
                )}
              </div>
              
              {index < totalSteps - 1 && (
                <div 
                  className={`${styles.stepConnector} ${
                    isCompleted ? styles.completed : styles.pending
                  }`}
                />
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default StepProgress;
